
import React, { useCallback, useEffect, useState } from 'react';
import moment from "moment";
import { TimePicker, Tabs } from 'antd';
import styles from './CustomTimePicker.module.scss';
import 'react-day-picker/dist/style.css';
import { useTranslation } from 'next-i18next';
import StaticTime from './StaticTime';

function CustomTimePicker(props) {
    const [showPicker, setShowPicker] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const { t, i18n } = useTranslation();
    const onChange = useCallback((key) => {
        setActiveTab(key)
    }, []);
    const format = 'HH:mm';
    moment.locale(i18n.language);
    const items = [
        {
            key: '1',
            label: 'Tab 1',
            children: <StaticTime onChange={(val) => props.setSelected(val)} />,
        },
        {
            key: '2',
            label: 'Tab 2',
            children: <TimePicker.RangePicker
                format={format}
                open={activeTab === '2'}
                minuteStep={10}
                onChange={(e) => {
                    props.setSelected({
                        from: `${e[0].$H}:${e[0].$m}`,
                        to: `${e[1].$H}:${e[1].$m}`
                    })
                }} />,
        },

    ];

    return (
        <>
            <div className={styles.custom_picker}>
                {showPicker && <div onClick={() => setShowPicker(false)} className={styles.close}>x</div>}
                <div className={`d-flex gap-2 ${styles.inputCont}`}>
                    <input
                        className={styles.picker_input}
                        placeholder={t("houre")}
                        type='text'
                        value={props.selected.from ? `${props.selected.from}-${props.selected.to}` : ''}
                        onFocus={() => setShowPicker(true)}
                    // onBlur={() => setShowPicker(false)}
                    />
                   { props.selected.from && <span onClick={() => {
                        props.setSelected({
                            from: '',
                            to: ''
                        })
                    }} className={styles.closeIcon}>x</span>}
                </div>
                {showPicker && <div className={styles.day_picker_cont}>
                    <StaticTime onChange={(val) => {
                        setShowPicker(false)
                        props.setSelected(val)
                    }} />
                </div>}
            </div>
            {showPicker && <div onClick={() => setShowPicker(false)} className={styles.custom_picker_layer}></div>}
        </>
    );
}
export default CustomTimePicker;